import ThankYouPage, {
  getSpecialSubscriptionServerSideProps as getServerSideProps,
} from '@haaretz/s-pp-thankYou-page';

export default ThankYouPage;

export { getServerSideProps };
